import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"
import Helmet from 'react-helmet'

import capitalize from 'capitalize'

import Section from '../com/Section'
import Background from '../com/Background'
import BackgroundMobile from '../com/BackgroundMobile'
import BackgroundTablet from '../com/BackgroundTablet'
import BackgroundWideScreen from '../com/BackgroundWideScreen'
import Crosshairs from '../com/Crosshairs'
import Content from '../com/Content'
import Title from '../com/Title'
import Tag from '../com/Tag'
import P from '../com/P'
import Span from '../com/Span'
import Ul from '../com/Ul'
import Cta from '../com/Cta'
import H1 from '../com/H1'

const subscribeMessage = "follow us"

export default ({data}) => {
  const post = data.seeYaml;
  return(
    <div>
      <Helmet>
        <title>{capitalize(post.title)} | SUPERFRAME</title>
        <meta name="description" content={capitalize(post.description)} />
        {/* open graph tags */}
        <meta property="og:title" content={capitalize(post.title)} />
        <meta property="og:description" content={`${capitalize(post.description)}`} />
        <meta property="og:url" content={`${data.site.siteMetadata.url}${post.fields.slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={`${data.site.siteMetadata.url}${post.image.publicURL}`} />
        <meta property="og:image:width" content={post.image.childImageSharp.original.width} />
        <meta property="og:image:height" content={post.image.childImageSharp.original.height} />
        <meta property="og:image:alt" content={post.title} />
        <meta property="og:image:secure_url" content={`${data.site.siteMetadata.url}${post.image.publicURL}`} />

        <meta property="og:site_name" content={data.site.siteMetadata.title} />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:locale:alternate" content="en_US" />
      </Helmet>

      {/* Begin conditional video */}
      {(post.video != null ? //checks to see if our yaml has a video entered or not.
        <div>
          <Section>
          <Background>
            <video preload="auto" muted="true" muted autoPlay loop playsInline poster="">
              <source src={post.video.publicURL} type="video/mp4" />
              <p>Your browser does not support the video tag.</p>
            </video>
            {/* <Crosshairs /> */}
          </Background>
          <Content>
            {(post.title != null ? <H1 light>{post.title}</H1> : "")}
            <p>
              {(post.date != null ? <Span>{post.date}</Span> : "")}
              {(post.video != null ? <Span>,&nbsp;[video]</Span> : "" )}
            </p>
            {(post.description != null ? <Tag>{post.description}</Tag> : "")}
            {(post.client != null ? <P>For {capitalize(post.client)}</P> : "")}
            {(post.link != null ? <p><a href={post.link} target="_blank">{post.link}</a></p> : "")}
            <Cta to="/subscribe/">{subscribeMessage}</Cta>
          </Content>
        </Section>
        <Section>
          <BackgroundMobile>
              <Img sizes={post.image.childImageSharp.mobile}
                position={'relative'}
                alt={(post.title != null ? post.title : "")}
                style={{
                  height:`100vh`,
                }}
              />
            {/* <Crosshairs /> */}
          </BackgroundMobile>
          <BackgroundTablet>
              <Img sizes={post.image.childImageSharp.tablet}
                position={'relative'}
                alt={(post.title != null ? post.title : "")}
                style={{
                  height:`100vh`,
                }}
              />
          </BackgroundTablet>
          <BackgroundWideScreen>
              <Img sizes={post.image.childImageSharp.widescreen}
                position={'relative'}
                alt={(post.title != null ? post.title : "")}
                style={{
                  height:`100vh`,
                }}
              />
          </BackgroundWideScreen>
          <Content>
            {(post.title != null ? <H1 light>{post.title}</H1> : "")}
            <p>
              {(post.date != null ? <Span>{post.date}</Span> : "")}
            </p>
            {(post.description != null ? <Tag>{post.description}</Tag> : "")}
            {(post.client != null ? <P>For {post.client}</P> : "")}
            {(post.link != null ? <p><a href={post.link} target="_blank">{post.link}</a></p> : "")}
            <Cta to="/subscribe/">{subscribeMessage}</Cta>
          </Content>
        </Section>
      </div>
      : // : << this means 'else'
      // if there is no video, do this:
      <Section>
        <BackgroundMobile>
            <Img sizes={post.image.childImageSharp.mobile}
              position={'relative'}
              alt={(post.title != null ? post.title : "")}
              style={{
                height:`100vh`,
              }}
            />
          {/* <Crosshairs /> */}
        </BackgroundMobile>
        <BackgroundTablet>
            <Img sizes={post.image.childImageSharp.tablet}
              position={'relative'}
              alt={(post.title != null ? post.title : "")}
              style={{
                height:`100vh`,
              }}
            />
        </BackgroundTablet>
        <BackgroundWideScreen>
            <Img sizes={post.image.childImageSharp.widescreen}
              position={'relative'}
              alt={(post.title != null ? post.title : "")}
              style={{
                height:`100vh`,
              }}
            />
        </BackgroundWideScreen>
        <Content>
          {(post.title != null ? <H1 light>{post.title}</H1> : "")}
          <p>
            {(post.date != null ? <Span>{post.date}</Span> : "")}
          </p>
          {(post.description != null ? <Tag>{post.description}</Tag> : "")}
          {(post.client != null ? <P>For {post.client}</P> : "")}
          {(post.link != null ? <p><a href={post.link} target="_blank">{post.link}</a></p> : "")}
          <Cta to="/subscribe/">{subscribeMessage}</Cta>
        </Content>
      </Section>
    )}
    {/* End of conditional video */}
    </div>
  ) //end return
}; //end export default

export const BlogPostQuery = graphql`
  query ResponsiveImageBlogPostQuery ($slug: String!) {
  seeYaml (fields: { slug: { eq: $slug } }) {
    fields {
      slug
    }
    title
    description
    date (formatString: "DD MMM YYYY")
    image{
      relativePath
      publicURL
      childImageSharp{
        # sizes (maxWidth: 2560){
        #   sizes
        #   base64
        #   src
        #   srcSet
        # }
        # sizes(maxWidth:1440, maxHeight:2560, quality: 70, cropFocus: CENTER) {
        # ...GatsbyImageSharpSizes
        # }
        mobile:resolutions(width:1440, height:2560, quality: 50, cropFocus: CENTER) {
        ...GatsbyImageSharpResolutions
        }
        tablet:resolutions(width:2048, height:2960, quality: 50, cropFocus: CENTER) {
        ...GatsbyImageSharpResolutions
        }
        widescreen:resolutions(width:2560, height:1440, quality: 65, cropFocus: CENTER) {
        ...GatsbyImageSharpResolutions
        }
        # resize(width:1440, quality: 70, cropFocus: CENTER){
        #   src
        # }
        #original width and height used for open graph data
        original{
          width
          height
        }
      }
    } # end image
    video{
      publicURL
    }
    client
    link
  }
  site{
    siteMetadata{
      url
      title
    }
  }
}
`
// I have adjusted the queries about to work only for a portrait mobile phone screen, providing retina imagery.



// WEBPACK FOOTER //
// ./src/templates/see-post-responsive.js